<ng-container *transloco="let convert;">
  <div class="alerts-sellers" data-test-id="alerts-sellers-container">
    <h2 data-test-id="alerts-sellers-header" tabindex="-1" #pageHeading aria-describedby="pageDescription">{{convert('profileManagement.alertsSellers.pageHeader')}}</h2>
    <p data-test-id="alerts-sellers-description" id="pageDescription" [innerHTML]="convert('profileManagement.alertsSellers.contentSelectPreferences', {tenantShortName : tenantShortName})"></p>

    <app-legacy-table data-test-id="alerts-sellers-table" [columns]="columns" [data]="data" [tenantName]="tenantName$ | async" [cardConfig]="cardConfig">
      @for (row of data; track row) {
        <table-row-group>
          <table-row [columns]="columns" [row]="row">
            <table-cell *appTableCell="let row; column: 'options'">
              <button
                data-test-id="alerts-sellers-manage-btn"
                data-track-elem="button"
                data-track-name="Manage"
                class="btn btn-link p-0 pb-1 pb-m-0"
                (click)="openDrawer(drawer)"
                >
                {{convert('profileManagement.alertsSellers.labelManage')}}
              </button>
            </table-cell>
          </table-row>
          <table-row [ngClass]="drawer" [row]="row" [expandable]="true" #drawer="table-row">
            <table-cell *appTableCell="let row; colSpan: columns.length">
              <div class="drawer-header" data-test-id="alerts-sellers-drawer-header">
                <h1 data-test-id="alerts-sellers-drawer-title" class="manage-alerts-title">{{convert('profileManagement.alertsSellers.manageAlertsTitle')}}</h1>
                <button
                  data-test-id="alerts-sellers-drawer-close-btn"
                  data-track-elem="icon"
                  data-track-name="Close"
                  data-track-trigger="close"
                  class="btn btn-link drawer-header__close"
                  (click)="openCancelChangesModal(modalId)"
                  >
                  <i class="allycon-glyph-close custom__dropdown--icon radiu_dropdown_icon text-primary"></i>
                </button>
              </div>
              <!-- <form class="form"> -->
              <table data-test-id="alerts-sellers-manage-table" class="manage-alerts-table">
                <!-- title table row -->
                <tr class="manage-alerts-table__row manage-alerts-table__row--heading">
                  <th scope="col" class="manage-alerts-table__heading-item">{{convert('profileManagement.alertsSellers.tableHeaderAlertsWhen')}}</th>
                  <th scope="col" class="manage-alerts-table__heading-item text-center">{{convert('profileManagement.alertsSellers.tableHeaderEmail')}}</th>
                </tr>
                <!-- tyical table row -->
                <tr>
                  <td>{{convert('profileManagement.alertsSellers.offersViEmail')}}</td>
                  <td>
                    <div class="custom-control custom-checkbox">
                      <input
                        data-test-id="alerts-sellers-offer-submitted-checkbox"
                        [checked]="offerSubmitted"
                        class="custom-control-input"
                        id="question-option-1"
                        type="checkbox"
                        />
                      <label class="custom-control-label" for="question-option-1"></label>
                    </div>
                  </td>
                </tr>
                <!-- tyical table row -->
                <tr>
                  <td>{{convert('profileManagement.alertsSellers.offerExpiring')}}</td>
                  <td>
                    <div class="custom-control custom-checkbox">
                      <input data-test-id="alerts-sellers-first-bid-checkbox" [checked]="firstBid" class="custom-control-input" id="question-option-2" type="checkbox" />
                      <label class="custom-control-label" for="question-option-2"></label>
                    </div>
                  </td>
                </tr>
                <!-- tyical table row -->
                <tr>
                  <td>{{convert('profileManagement.alertsSellers.questionsViaEmail')}}</td>
                  <td>
                    <div class="custom-control custom-checkbox">
                      <input data-test-id="alerts-sellers-vehicle-sold-checkbox" [checked]="vehicleSold" class="custom-control-input" id="question-option-3" type="checkbox" />
                      <label class="custom-control-label" for="question-option-3"></label>
                    </div>
                  </td>
                </tr>
                <!-- tyical table row -->
                <tr>
                  <td>{{convert('profileManagement.alertsSellers.firstBidOrSale')}}</td>
                  <td>
                    <div class="custom-control custom-checkbox">
                      <input
                        data-test-id="alerts-sellers-question-submitted-checkbox"
                        [checked]="questionSubmitted"
                        class="custom-control-input"
                        id="question-option-4"
                        type="checkbox"
                        />
                      <label class="custom-control-label" for="question-option-4"></label>
                    </div>
                  </td>
                </tr>
                <!-- tyical table row plus a dropdown -->
                <tr>
                  <td>
                    <div class="hours-thing">
                      <span data-test-id="alerts-sellers-summary-report-label">
                        {{convert('profileManagement.alertsSellers.sellerSummaryReport')}}
                      </span>
                      <!-- <div class="flex-grow-1">
                      <div class="form-group custom-select-container select-wrapper">
                        <select formControlName="endModelYear" id="endModelYear" class="custom-select">
                          <option *ngFor="let hour of hoursOptions" value="{{ hour.value }}">{{ hour.key }}</option>
                        </select>
                      </div>
                    </div>
                    <span>
                      &nbsp;&nbsp;hours
                    </span> -->
                  </div>
                </td>
                <td>
                  <div class="custom-control custom-checkbox">
                    <input
                      data-test-id="alerts-sellers-offer-expiring-checkbox"
                      [checked]="offerExpiring"
                      class="custom-control-input"
                      id="question-option-5"
                      type="checkbox"
                      />
                    <label class="custom-control-label" for="question-option-5"></label>
                  </div>
                </td>
              </tr>
            </table>
            <div class="manage-alerts__button-container">
              <button data-test-id="alerts-sellers-save-btn" data-track-elem="button" data-track-name="Save" class="btn btn-primary" (click)="closeDrawer()">
                {{convert('common.btnSave')}}
              </button>
              <button
                data-test-id="alerts-sellers-cancel-btn"
                data-track-elem="button"
                data-track-name="Cancel"
                class="btn btn-secondary bid-buttons"
                (click)="openCancelChangesModal(modalId)"
                >
                {{convert('common.btnCancel')}}
              </button>
            </div>
          <!-- </form> -->
        </table-cell>
      </table-row>
    </table-row-group>
  }
</app-legacy-table>
</div>
<app-save-changes-modal
  data-test-id="alerts-sellers-save-changes-modal"
  (cancelEditing)="cancelEditing()"
  (continueEditing)="continueEditing()"
  [modalId]="modalId"
  data-track-region="Sellers Alerts"
></app-save-changes-modal>
</ng-container>
